<template>
    <section :class="{ 'testcafe' : isTestCafeEnabled() }">
        <router-view></router-view>
    </section>
</template>

<script>
import { isTestCafeEnabled } from '@/helpers/isTestCafeEnabled'

export default {
    created () {
        dataLayer.push({ 'event': 'payment_form.loaded' })

        this.$validator.localize('pl', {
            messages: {
                email: 'Błędny email',
                required: 'To pole jest wymagane.',
                digits: 'Błędny numer',
                alpha: 'Niepoprawna wartość',
                min: 'Wpisana wartość jest za krótka',
                regex: 'Niepoprawna wartość'
            },
            custom: {
                amount_other: {
                    required: 'Niepoprawna kwota.',
                    numeric: 'Niepoprawna kwota.',
                    min_value: 'Niepoprawna kwota. Minimalna kwota wpłaty to 2 zł.'
                },
                'consents[95]': {
                    required: 'Ta zgoda jest wymagana'
                },
                email: {
                    regex: 'Błędny email',
                    max: 'Podany email jest za długi'
                },
                currentMethod: {
                    required: 'Wybierz metodę płatności'
                },
            }
        })
        this.$validator.localize('pl')
    },
    methods: {
        isTestCafeEnabled
    }
}
</script>
